export const environment = {
  production: false,
  NODE_ENV: 'production',

  // Default Phone Number
  VUE_APP_MAIN_PHONE: '855-227-3259',

  // Local 3000
  VUE_APP_BACKEND_HOST: 'http://localhost:3000',
  VUE_APP_WEBRTC_URL: 'http://localhost:3000',
  VUE_APP_INVITEE_VALIDATION_URL: 'http://localhost:1024/invitee',
  VUE_APP_INVITEE_REDIRECT_URL: 'http://localhost:1024/invitee',
  VUE_APP_MEDIA_SOUP: 'http://localhost:3008',

  VUE_APP_GOOGLE_MAPS_KEY: 'AIzaSyAx5vxOMwxfXivvTBgJN9TAacJEEZXJlj4',

  // Recaptcha
  VUE_APP_RECAPTCHA_SITE_KEY: '6LeoX8crAAAAAP1YmeD2N_9mbGTd9L9gbVe5ajrt',

  // MapBox
  VUE_APP_MAP_BOX_KEY:
    'pk.eyJ1IjoidmxhZGltaXJzaGtyb2JvdCIsImEiOiJjazk0OTJodDkwM2IwM2duM2VlN2lzMzRpIn0.X2r4dS-W4er8t8iC08aTJQ',

  // Pillar Payment
  VUE_APP_PILLAR_COLLECT_KEY: '64Q6tB-a3PH66-p8sZ83-E96pj6',

  // Sentry
  VUE_APP_SENTRY_DSN: '',
  VUE_APP_SENTRY_ENV: 'local',

  // Prod E-prescribe account
  // VUE_APP_EAZY_SCRIPTS_SUB_DOMAIN: 'careclix',
  // VUE_APP_EAZY_SCRIPTS_PREFIX: 'careclix',
  // VUE_APP_EAZY_SCRIPTS_KEY: '9dd94893-6bfb-4161-ad21-8b0b5d7548e5',
  // VUE_APP_EAZY_SCRIPTS_SECRET: '13-9e2132dd-b843-4eb6-b838-2d63b320fb45',

  // CYPRESS
  CYPRESS_BASE_URL: 'http://localhost:1024',
  CYPRESS_CLINIC_STRIPE: 'timon',
  CYPRESS_CLINIC_PILLAR: 'timonpillar',
  CYPRESS_USERNAME_SUPER_ADMIN: 'timasuperadmin',
  CYPRESS_USERNAME_CLINIC_ADMIN: 'timaclinicadmin',
  CYPRESS_USERNAME_PROVIDER1: 'timaprovider',
  CYPRESS_USERNAME_PATIENT1: 'timapatient',
  CYPRESS_USERNAME_PATIENT_PILLAR: 'timapatientpillar',
  CYPRESS_COMMON_PASSWORD: 'Tima1981!',
  CYPRESS_USE_PILLAR: true,

  // PostAffiliatePro | Sideqik
  VUE_APP_AFFILIATE_PROGRAM: 'PostAffiliatePro',

  // Sideqik pixel
  VUE_APP_SIDEQIK_LINK: 'https://d1hrk5gt3yn7pi.cloudfront.net/api/sideqik-api-1.4.js',
  VUE_APP_SIDEQIK_HASH: '648d14a1799b350045f2305e',

  // Post Affiliate Pro
  VUE_APP_POST_AFFILIATE_PRO_DOMAIN: 'myguardiandoc.postaffiliatepro.com',
};
